import React, { useState } from 'react';
import './ExpandableText.css';

const ExpandableText = ({ text, maxLines = 3 }) => {
    const [expanded, setExpanded] = useState(false);
    const toggle = () => setExpanded(!expanded);

    if (!text) return '-';

    const lineLimitStyle = {
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'pre-wrap',
    };

    return (
        <div className="expandable-text">
            <div style={expanded ? {} : lineLimitStyle}>
                {text}
            </div>
            {text.split('\n').length > maxLines || text.length > 100 ? (
                <span className="readmore-text" onClick={toggle}>
                    {expanded ? ' ...Show less' : '... Read more'}
                </span>
            ) : null}
        </div>
    );
};

export default ExpandableText;
